import { useState, useCallback } from 'react';

/**
 * Hook to manage global notification state and handlers.
 * Extracted from App.js to reduce component complexity.
 */
export const useGlobalNotifications = () => {
  const [globalNotifications, setGlobalNotifications] = useState([]);

  const addGlobalNotification = useCallback((type, gameId, roomName, message, requesterId = null) => {
    const newNotification = {
      id: Date.now(),
      type,
      gameId,
      roomName,
      message,
      requesterId,
      timestamp: new Date().toISOString(),
      read: false
    };
    
    setGlobalNotifications(prev => {
      const updated = [newNotification, ...prev].slice(0, 30);
      return updated;
    });
  }, []);

  const clearGlobalNotification = useCallback((notificationId) => {
    setGlobalNotifications(prev => prev.filter(n => n.id !== notificationId));
  }, []);

  const clearAllGlobalNotifications = useCallback(() => {
    setGlobalNotifications([]);
  }, []);

  return {
    globalNotifications,
    addGlobalNotification,
    clearGlobalNotification,
    clearAllGlobalNotifications
  };
};

export default useGlobalNotifications;
